const subscriptionNames = [
    "AI Model Building",
    "Real-time Surveillance",
    "Product Pricing",
    //Behavior Analytics
];

export default subscriptionNames;